import { render, staticRenderFns } from "./ChooseOrg.vue?vue&type=template&id=6deeb08f&scoped=true&"
import script from "./ChooseOrg.vue?vue&type=script&lang=js&"
export * from "./ChooseOrg.vue?vue&type=script&lang=js&"
import style0 from "./ChooseOrg.vue?vue&type=style&index=0&id=6deeb08f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6deeb08f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VHover } from 'vuetify/lib/components/VHover';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VCardTitle,VHover,VImg})
